// Create a jest file for the RestaurantCard component.

import React from 'react'
import { render, screen } from '@testing-library/react'
import RestaurantCard from '../RestaurantCard'
import { RestaurantCardProps } from '../types.d'

const baseProps: RestaurantCardProps = {
  bgColor: 'bg-gray-0',
  ctaLabel: 'Test CTA Label',
  ctaLink: 'https://www.toasttab.com',
  description: 'Test Description',
  heading: 'Test Title',
  padding: '24'
}
describe('RestaurantCard UI Tests', () => {
  it('Should display RestaurantCard', () => {
    render(<RestaurantCard {...baseProps} />)
    expect(screen.getByTestId('restaurantcard')).toBeTruthy()
  })

  it('Should display RestaurantCard with a heading', () => {
    render(<RestaurantCard {...baseProps} />)
    expect(screen.getByText('Test Title')).toBeTruthy()
  })

  it('Should display RestaurantCard with a description', () => {
    render(<RestaurantCard {...baseProps} />)
    expect(screen.getByText('Test Description')).toBeTruthy()
  })

  it('Should display RestaurantCard with a borderColor', () => {
    render(<RestaurantCard {...baseProps} borderColor='dark' />)
    expect(screen.getByTestId('restaurantcard')).toHaveClass('border-card-dark')
  })

  it('Should display RestaurantCard with an elevation', () => {
    render(<RestaurantCard {...baseProps} elevation='raised' />)
    expect(screen.getByTestId('restaurantcard')).toHaveClass('shadow-raised')
  })

  it('Should display RestaurantCard with images', () => {
    render(
      <RestaurantCard
        {...baseProps}
        images={{
          imageResolutions: [
            {
              desktop: [
                {
                  exension: 'png',
                  url: 'https://d2w1ef2ao9g8r9.cloudfront.net/images/demo@2x.png',
                  title: 'demo',
                  optimizedImages: {
                    srcAvif:
                      'https://d2w1ef2ao9g8r9.cloudfront.net/images/_1600x1575_crop_center-center_82_line/demo@2x.png.webp'
                  }
                }
              ],
              tablet: [],
              mobile: [],
              borderRadius: {
                label: 'Medium'
              }
            }
          ]
        }}
      />
    )
    expect(
      screen.getByTestId('mds-imageResolutions-img').getAttribute('src')
    ).toEqual('https://d2w1ef2ao9g8r9.cloudfront.net/images/demo@2x.png')
  })

  it('Should display RestaurantCard with a badgeColor and badgeText', () => {
    render(
      <RestaurantCard
        {...baseProps}
        badgeColor='bg-lavender-0'
        badgeText='top'
      />
    )
    expect(screen.getByText('top')).toBeTruthy()
  })

  it('Should display RestaurantCard with a list', () => {
    render(
      <RestaurantCard
        {...baseProps}
        list={[
          '2 Toast Flex, Toast Tap, Toast Printer Bundles',
          '1 Toast Go® Handheld',
          '1 Cash Drawer',
          '1 Ethernet Switch'
        ]}
      />
    )
    expect(
      screen.getByText('2 Toast Flex, Toast Tap, Toast Printer Bundles')
    ).toBeTruthy()
    expect(screen.getByText('1 Toast Go® Handheld')).toBeTruthy()
    expect(screen.getByText('1 Cash Drawer')).toBeTruthy()
    expect(screen.getByText('1 Ethernet Switch')).toBeTruthy()
  })

  it('Should display RestaurantCard with a ctaLink, ctaLabel', () => {
    render(<RestaurantCard {...baseProps} />)
    expect(screen.getByText('Test CTA Label')).toBeTruthy()
  })

  it('Should display RestaurantCard with a ctaLink, ctaLabel, and linkIcons arrow', () => {
    render(<RestaurantCard {...baseProps} linkIcons='arrow' />)
    expect(screen.getByText('Test CTA Label')).toBeTruthy()
    expect(screen.getByTestId('TextLinkIcons-arrow')).toBeTruthy()
  })
})
